import { useEffect, useState } from 'react'
import * as con from "./../Constants"

import { I18n } from 'i18n-js';

// Languages
import en from "../languages/en.json"
import ee from "../languages/ee.json"


import { RefStoredValue } from './StoreHooks';
import { getStoredValue, setStoredValue } from '../store/actions';


// Set the key-value pairs for the different languages you want to support.
const baseLanguages = {
    [con.EN]: en,
    [con.EE]: ee,

}

const baseI18n = new I18n(baseLanguages);
baseI18n.locale = con.EN
baseI18n.enableFallback = true;

export const RefLanguage = () => {

    const currentLocale = RefStoredValue(con.STORAGE_CURRENT_LOCAL)
    const [i18n, setI18n] = useState(baseI18n)



    // If locale changes
    useEffect(() => {

        const newI18n = new I18n(baseLanguages);
        newI18n.locale = currentLocale
        newI18n.enableFallback = true;

        setI18n(newI18n)

    }, [currentLocale])


    return i18n

}

export const setLocale = (newLocale) => {
    setStoredValue(con.STORAGE_CURRENT_LOCAL, newLocale)
}



export const getCurrentI18n = () => {
    const currentLocale = getStoredValue(con.STORAGE_CURRENT_LOCAL)
    const newI18n = new I18n(baseLanguages);
    newI18n.locale = currentLocale
    newI18n.enableFallback = true;

    return (newI18n)
}
